import { Image, StyleSheet, View } from 'react-native'
import Text from "theme/Text";
import React, { useEffect, useMemo, useState } from 'react'
import FetchEmailExternal from 'utils/fetch/FetchEmailExternal'
import Title from 'components/atoms/Title'
import _ from 'lodash'
import LoadingComponent from 'components/atoms/Loading'
import VStack from 'components/atoms/stack/VStack'
import Icon from 'assets/icon.png'
import { ThemedValues } from 'styles/themed'
import HStack from 'components/atoms/stack/HStack'
import i18n from 'utils/i18n'
import HelperJson from 'utils/HelperJson'
import GraphqlBuilder, { graphqlOptions } from 'utils/request/graphql/builder'
import MutationEmailResponse from 'graphql/mutations/MutationEmailResponse'
import Button from 'theme/Button'

const EmailResponse = ({ guid }) => {
	
	const [ email, setEmail ] = useState( null );
	const [ mutating, setMutating ] = useState( false );
	
	const onPressAction = ( action ) => {
		new GraphqlBuilder( { [ graphqlOptions.processVariables ]: false })
			.addQuery( 'mutation', MutationEmailResponse, {
				guid,
				response_value: action.value,
			})
			.setResultPath( ['mutation', 'mutation_email_external_response'], {} )
			.setOnStart( () => {
				setMutating( true );
			})
			.setOnSuccess( ( result ) => {
				fetchEmail();
			})
			.setOnError( ( result ) => {
				setMutating( false );
			})
			.execute()
	}
	
	const fetchEmail = () => {
		FetchEmailExternal.fetch( guid, {
			callbackSuccess: ( response ) => {
				setEmail( response );
				setMutating( false );
			}
		})
	}
	
	useEffect( () => {
		fetchEmail();
	}, [ guid ] );
	
	const content = useMemo( () => {
		if( !_.isEmpty( email ) ) {
			
			const actions = HelperJson.isJson( email.actions ) ? JSON.parse( email.actions ) : null;
			
			return (
				<VStack>
					<Title>
						{ email.subject }
					</Title>
					
					<Text>{ email.text }</Text>
					
					{ email.sub_text && (
						<View
							style={ styles.subTextContainer }>
							
							<Text style={ styles.subText }>{ email.sub_text }</Text>
						</View>
					)}
					
					{ actions !== null && (
						<HStack
							style={styles.subTextContainer}>
							
							{ _.map( actions, ( action, index ) => {
								return (
									<Button
										onPress={ onPressAction.bind( this, action ) }
										isLoading={ mutating }>

										{ action.label }
									</Button>
								);
							})}
						</HStack>
					)}
				</VStack>
			)
		}
		
		return (
			<LoadingComponent />
		)
	}, [ email ] );
	
	return (
		<VStack
			space={ 12 }>
			
			<View
				style={ styles.icon }>
				
				<HStack
					space={ 12 }
					style={styles.hStackAlignItemsCenter}>
					
					<Image
						style={ styles.iconImage }
						resizeMode="contain"
						source={ Icon }
					/>
					
					<Title
						style={ styles.title }>
						
						{ i18n.t( 'app_name' ) }
					</Title>
				</HStack>
			</View>
			
			<View
				style={ styles.content }>
				
				{ content }
			</View>
		</VStack>
	)
}

const styles = StyleSheet.create({
	hStackAlignItemsCenter: {
		alignItems: 'center',
	},
	icon: {
		//alignItems: 'center',
	},
	iconImage: {
		width: 75,
		height: 75,
	},
	
	title: {
		color: '#fff',
		marginBottom: 0,
		fontSize: 24,
	},
	
	content: {
		borderRadius: ThemedValues.borderRadius,
		backgroundColor: '#fff',
		padding: ThemedValues.marginHorizontal
	},
	
	subTextContainer: {
		marginTop: 14,
	},
	subText: {
		fontWeight: 'bold',
	}
})

export default EmailResponse;
